// extracted by mini-css-extract-plugin
module.exports = {"page":"_4xx_page__1Sa6l","container":"_4xx_container__2Dfp-","fontSizeAdjust":"_4xx_fontSizeAdjust__UDfjR","buttonGroup":"_4xx_buttonGroup__2u030"};